import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';
import React, { useState } from 'react';


const FindCreateForm = ({ selectedKey,setSelectedKey,dataLoading = false, filteredData = [], filterKeys, selectedRows, setSelectedRows }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleCheckboxChange = (row) => (event) => {
    console.log(row)
    if (event.target.checked) {
      setSelectedRows([...selectedRows, row?.vehicleId]);
      setSelectedKey([...selectedKey, row?.id])
    } else {
      setSelectedRows(selectedRows?.filter((i) => i !== row?.vehicleId));
      setSelectedKey(selectedKey?.filter((i) => i !== row?.id))
    }
  };

  const getFindData = (row, key) => {
    if (Array.isArray(row[key]) && key === 'engines') {
      const data = row[key];
      if (data?.length >= 1) {
        return (
            <>{data?.map((item, idx) => (
<>
      <span>{item?.engineName}</span>
      {idx !== data.length - 1 && <span>,{"  "}</span>}
    </>
            ))}</>
        );
      }
    } else {
      return <>{row[key]}</>;
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginationData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Filtered Results ({filteredData?.length})
      </Typography>
      <Paper elevation={2}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: 'rgb(229, 231, 243)' }}>
            <TableRow>
              <TableCell padding="checkbox" />
              {filterKeys?.map(({ key, label }) => (
                <TableCell key={key} sx={{ fontWeight: 'bold' }}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataLoading ? (
              <TableRow>
                <TableCell colSpan={filterKeys?.length + 1} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : filteredData?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={filterKeys?.length + 1} align="center">
                  No data found.
                </TableCell>
              </TableRow>
            ) : (
              paginationData?.map((row, index) => (
                <TableRow key={index} hover sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } }}>
                  <TableCell padding="checkbox">
                    <input
                      type="checkbox"
                      onChange={handleCheckboxChange(row)}
                      checked={selectedKey?.includes(row?.id)}
                    />
                  </TableCell>
                  {filterKeys?.map(({key, data }) => (
                    <TableCell key={data}>{getFindData(row, key)}</TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </>
  );
};

export default FindCreateForm;